<template>
  <li class="sb-item" :class="product.text ? 'sb-item-banner' : ''">
    <template v-if="product.url">
      <span v-if="product.sale_banner" class="sb-sale">
        <template v-if="product.sale_banner == true">sale</template>
        <template v-else>{product.sale_banner}</template>
      </span>
      <a
        class="sb-item-img"
        :href="product.url"
        @click="emitUserDetails(product.sku, product.url)"
      >
        <img :src="product.imageUrl" />
      </a>
      <div class="sb-item--details">
        <div
          class="sb-clamp"
          @click="emitUserDetails(product.sku, product.url)"
        >
          <h4>{{ product.name }}</h4>
        </div>
        <div class="sb-price-wraper">
          <template v-if="product.inc_vat">
            <p class="price" @click="emitUserDetails(product.sku, product.url)">
              <span
                v-if="product.priceFrom == true"
                style="font-weight: bold !important; margin: 0 2px"
                >from</span
              >
              {{ currency }}{{ addZeroes(product.price) }}
              <span
                style="
                  font-size: 12px !important;
                  font-weight: 600 !important;
                  margin: 0 2px;
                "
                >Ex VAT.</span
              >
            </p>
            <p class="price" @click="emitUserDetails(product.sku, product.url)">
              {{ currency }}{{ addZeroes(product.inc_vat)
              }}<span
                style="
                  font-size: 12px !important;
                  font-weight: 600 !important;
                  margin: 0 2px;
                "
              >
                Inc. VAT.</span
              >
            </p>
          </template>
          <template v-else>
            <p
              class="price"
              @click="emitUserDetails(product.sku, product.url)"
              v-if="product.price == 0 && client == 'buildfourless'"
            >
              <a
                href="tel:020-3481-1978"
                style="text-decoration: underline; min-height: 40px"
                >Call for price</a
              >
            </p>
            <p
              class="price"
              :class="
                product.originalPrice != false && product.originalPrice != null
                  ? 'sb-price-red'
                  : ''
              "
              @click="emitUserDetails(product.sku, product.url)"
              v-else
            >
              <template v-if="currency == 'kr.'">
                <template v-if="client == 'interfloradk'"> Fra </template>
                {{ addZeroes(product.price) }} {{ currency }}
              </template>
              <template v-else>
                {{ currency }}{{ addZeroes(product.price) }}
              </template>
            </p>
            <span
              v-if="
                product.originalPrice != false && product.originalPrice != null
              "
            >
              Was
              <span
                style="
                  font-size: 1.4rem;
                  font-weight: 300;
                  text-decoration: line-through !important;
                "
              >
                {{ currency }} {{ addZeroes(product.originalPrice) }}
              </span>
            </span>
          </template>
        </div>

        <span
          class="sb-sku"
          @click="emitUserDetails(product.sku, product.url)"
          >{{ product.sku }}</span
        >
        <div class="btn-wrap">
          <a
            @click="emitUserDetails(product.sku, product.url)"
            class="product-btn btn-secondary"
            >{{ content[lang].buttons.details }}</a
          >
          <a class="product-btn" @click="findSimilarTrigger(product.sku)">
            {{ content[lang].buttons.similar }}
          </a>
        </div>
      </div>
    </template>
    <template v-else>
      <a :href="product.link" @click="emitBannerClick">
        {{ product.text }} <br />
      </a>
      <div class="btn-wrap">
        <a
          :href="product.btns[0].link"
          @click="emitBannerClick"
          class="product-btn btn-secondary"
          >{{ product.btns[0].text }}</a
        >
        <a
          :href="product.btns[1].link"
          @click="emitBannerClick"
          class="product-btn btn-secondary"
          >{{ product.btns[1].text }}</a
        >
      </div>
    </template>
  </li>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    product: {
      type: Object,
    },
  },
  computed: {
    ...mapState([
      "uuid",
      "site",
      "client",
      "c_page",
      "currency",
      "content",
      "lang",
      "decimalcomma",
      "similarOpen",
      "control_flag",
    ]),
    isKos() {
      if (localStorage.getItem("isKos")) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    addZeroes: function (num) {
      const dec = num.toString().split(".")[1];
      const len = dec && dec.length > 2 ? dec.length : 2;
      if (this.decimalcomma == true) {
        return Number(num)
          .toFixed(len)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
          .toString()
          .replace(".", ",");
      } else {
        if (this.client == "designyard") {
          return Number(num)
            .toFixed(len)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
            .split(".")[0];
        } else {
          return Number(num)
            .toFixed(len)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        }
      }
    },
    findSimilarTrigger(sku) {
      let excludeHistory =
        this.similarOpen && this.similarOpen == true ? true : false;
      this.$parent.$parent.$parent.$emit("toggleSimilar", {
        toggle: true,
        page: 1,
        force: true,
        reset: true,
        sku: sku,
        excludeHistory: excludeHistory,
      });
      this.$store.dispatch("emitEvent", {
        data: {
          page: this.c_page,
          productid: sku,
          sbAction: `FindSimilar`,
          site: this.client,
          source:
            this.$parent.collection.charAt(0).toUpperCase() +
            this.$parent.collection.slice(1),
          uuid: this.uuid,
        },
        headers: {},
        type: "sbaction",
      });
    },
    emitUserDetails(id, url) {
      this.$store
        .dispatch("emitEvent", {
          data: {
            productid: id,
            uuid: this.uuid,
            site: this.client,
            sbAction: `Details`,
            page: this.c_page,
            source:
              this.$parent.collection.charAt(0).toUpperCase() +
              this.$parent.collection.slice(1),
          },
          headers: {},
          type: "sbaction",
        })
        .then(() => {
          window.location = url;
        });
    },
    emitBannerClick() {
      this.$store.dispatch("emitEvent", {
        data: {
          productid: "",
          uuid: this.uuid,
          site: this.client,
          sbAction: `BannerDetails`,
          page: this.c_page,
          source:
            this.$parent.collection.charAt(0).toUpperCase() +
            this.$parent.collection.slice(1),
        },
        headers: {},
        type: "sbaction",
      });
    },
  },
};
</script>

<style scoped>
#shopbox * {
  margin: 0;
}
#shopbox .sb-item.sb-item-banner {
  border: 1px solid var(--shopbox-main);
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
#shopbox .sb-item.sb-item-banner > a {
  margin-bottom: 10px;
  font-size: 14px;
}
#shopbox .sb-item.sb-item-banner .btn-wrap {
  height: auto;
  flex-direction: column;
  width: 100%;
  position: relative;
  z-index: 2;
}
#shopbox .sb-item.sb-item-banner .btn-wrap a {
  margin: 5px auto !important;
  width: 100% !important;
  font-size: 13px !important;
  justify-content: center;
  z-index: 2;
}
#shopbox .sb-item.sb-item-banner:after {
  content: "";
  background-color: var(--shopbox-main);
  opacity: 0.08;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0;
  z-index: 1;
}
#shopbox .sb-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  flex-basis: 34%;
  min-width: 28%;
  height: 100%;
  margin: 0;
  margin-right: 1%;
  margin-left: 1%;
  padding: 6px 16px;
  background: var(--shopbox-text-light);
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.2142) !important;
  border-radius: 10px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}
#shopbox .sb-sale {
  height: 20px;
  width: 100px;
  color: #fff;
  top: 15px;
  left: -25px;
  position: absolute;
  background-color: var(--shopbox-main);
  transform: rotate(-45deg);
}
#shopbox .product-btn.btn-secondary {
  background: #fff;
  color: var(--shopbox-main);
  border: 1px solid var(--shopbox-main);
  transition: all 200ms ease-out;
  padding: 1px 15px;
}
#shopbox .btn-wrap {
  display: flex;
  justify-content: space-between;
  height: 28px;
  margin: 6px 0;
}
#shopbox .product-btn {
  text-decoration: none;
  padding: 0px 6px;
  display: flex;
  align-items: center;
  background: var(--shopbox-main);
  color: var(--shopbox-text-light);
  border-radius: 4px;
  margin: 0px 4px;
  height: 100%;
  transition: all 200ms ease-out;
  cursor: pointer;
  white-space: nowrap;
  font-size: 12px !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  font-weight: normal !important;
  flex-basis: 50%;
  justify-content: center;
}
#shopbox .product-btn:first-of-type {
  margin-left: 0;
}
#shopbox .product-btn:last-of-type {
  margin-right: 0;
}
#shopbox .product-btn:hover {
  transform: scale(1.01);
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.5) !important;
}
@media (min-width: 768px) {
  #shopbox .sb-item--details {
    width: 100%;
  }
}
#shopbox .sb-sku {
  font-size: 0px;
  text-align: right;
  align-self: flex-end;
  height: 0;
  position: absolute;
}

#shopbox img {
  height: 100px;
  min-width: 100px;
  object-fit: contain;
  margin-bottom: 8px;
}
#shopbox .shopbox-portrait img {
  height: 160px;
}

#shopbox .sb-item img {
  max-width: 100% !important;
}
#shopbox .sb-clamp {
  max-height: 28px; /* line-height × 3 */
  overflow: hidden;
  height: 28px;
}

#shopbox .price {
  font-weight: bold;
  flex-direction: row !important;
  align-items: center !important;
}
#shopbox .sb-clamp > h4 {
  position: relative;
  margin: 0;
  padding: 0;
  line-height: 14px;
  font-size: 12px !important;
  font-weight: normal;
  letter-spacing: normal;
  text-transform: none;
}

#shopbox .sb-clamp > h4::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: calc(100% - 28px);
  background: repeating-linear-gradient(rgba(255, 255, 255, 0), #ffffff 25px);
}
.sb-price-wraper {
  min-height: 42px;
}
.sb-price-red {
  color: #a30000;
}
</style>
